import type { IntroVideoView } from "@/services/marketplaceService";
import { HlsPlayer } from "@/components/video/HlsPlayer";

const READY_STATUSES = new Set(["READY", "COMPLETE", "EXTERNAL", null, undefined]);

interface IntroVideoProps {
  introVideo?: IntroVideoView | null;
}

export function IntroVideo({ introVideo }: IntroVideoProps) {
  if (!introVideo) return null;
  if (introVideo.status !== undefined && !READY_STATUSES.has(introVideo.status)) return null;

  const { oembedHtml, playbackUrl, thumbnailUrl } = introVideo;

  if (!oembedHtml && !playbackUrl && !thumbnailUrl) return null;

  const isHls = playbackUrl?.includes('.m3u8');

  return (
    <section>
      <div className="flex items-center gap-3 mb-4">
        <div className="h-5 w-1 rounded-full bg-gradient-to-b from-[hsl(39,96%,48%)] to-[hsl(30,90%,45%)]" />
        <h2 className="text-xl font-bold text-foreground">Intro Video</h2>
      </div>
      <div className="rounded-2xl overflow-hidden shadow-md">
        {oembedHtml ? (
          <div
            className="relative aspect-video [&>iframe]:absolute [&>iframe]:inset-0 [&>iframe]:w-full [&>iframe]:h-full [&>iframe]:border-0"
            dangerouslySetInnerHTML={{ __html: oembedHtml }}
          />
        ) : playbackUrl && isHls ? (
          <HlsPlayer
            src={playbackUrl}
            poster={thumbnailUrl ?? undefined}
            className="w-full aspect-video"
          />
        ) : playbackUrl ? (
          <video
            src={playbackUrl}
            poster={thumbnailUrl ?? undefined}
            controls
            className="w-full aspect-video"
          />
        ) : thumbnailUrl ? (
          <img
            src={thumbnailUrl}
            alt="Intro video thumbnail"
            className="w-full aspect-video object-cover"
          />
        ) : null}
      </div>
    </section>
  );
}
